export const getServiceName = (): 'bubblechat' | 'tingle' => {
  return import.meta.env.VITE_APP_SERVICE_NAME || 'bubblechat'; // 기본값: bubblechat
};
